import { Satzart } from '@/types/Satzart';
import PatRezept from '@/types/PatRezept';

export default class Rezepteintrag {
    public patimpfung_id: number | null = null;
    public patnr: number | null = null;
    public impfdatum: string | null = null;
    public text: string | null = null;
    public teilimpfungsnr: number | null = 0;
    public satzart: number | null = Satzart.Rezept;
    public person_id_durchf: number | null = null;
    public impfstelle_id: number | null = null;
    public rezept: PatRezept = new PatRezept();
}
